import { AnalyticsArea, useAnalyticsEventTracker } from 'hooks/analytics-tracker'
import { CompositionTitleStyle, Invest, PortfolioCompositionWrapper, StyledText } from './style'
import React from 'react'
import { Text } from 'components'
export const EmptyComposition: React.FC = () => {
  const { navigationEvent } = useAnalyticsEventTracker(AnalyticsArea.Portfolio)
  return (
    <PortfolioCompositionWrapper className="portfolio-composition">
      <CompositionTitleStyle>Portfolio composition</CompositionTitleStyle>
      <StyledText>No assets currently held.</StyledText>
      <Invest buttonType={'primary'} onClick={() => navigationEvent('/#content')}>
        <Text>Invest</Text>
      </Invest>
    </PortfolioCompositionWrapper>
  )
}
export default EmptyComposition
